module.exports = __webpack_public_path__ + "static/media/TasklyMockUpTop.baa38178.png";